namespace AgerLMS.Logging {
    export interface ContactMessageRow {
        MessageId?: number;
        Fullname?: string;
        Email?: string;
        Phone?: string;
        Subject?: string;
        Message?: string;
        IpNo?: string;
        UserAgent?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace ContactMessageRow {
        export const idProperty = 'MessageId';
        export const nameProperty = 'Fullname';
        export const localTextPrefix = 'Logging.ContactMessage';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = 'Logging:ContactMessage:Read';
        export const updatePermission = '*';

        export declare const enum Fields {
            MessageId = "MessageId",
            Fullname = "Fullname",
            Email = "Email",
            Phone = "Phone",
            Subject = "Subject",
            Message = "Message",
            IpNo = "IpNo",
            UserAgent = "UserAgent",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
